import type { ActivityModule } from '../../core/activity';
import { runMagicHatActivity, filterStarsLevels } from '../../shared/magic-hat-runner';
import levelsData from './levels.json';
import './style.css';

const LEVELS = filterStarsLevels(levelsData.levels);

export const magicHatMinus: ActivityModule = {
  id: 'magic-hat-minus',
  title: 'Chapéu mágico (subtração)',
  description: 'Conte as estrelas e subtraia. Quantas estrelas sobraram?',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/magic-hat-minus/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) => runMagicHatActivity(ctx, {
    operation: 'minus',
    title: 'Chapéu mágico (subtração)',
    activityId: 'magic-hat-minus',
    levels: LEVELS,
  }),
};
